import { useSession } from "@outschool/ui-auth";
import { useFeatureFlag } from "@outschool/ui-components-shared";
import { Loading } from "@outschool/ui-legacy-component-library";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React from "react";
import { Route, Switch } from "react-router";

import ParentDashboardV2 from "../components/parentDashboardV2";
import { DASHBOARD_LINKS } from "../components/parentDashboardV2/constants";
import LoggedInHome from "./LoggedInHome";
import LoggedOutUserHome from "./LoggedOutUserHome";
import NotFoundPage from "./NotFoundPage";

export default function Home() {
  const { isLoggedIn, currentUserHasLoaded } = useSession();
  const shouldShowNewParentDashboard = useFeatureFlag(
    "new-parent-dashboard-v1"
  );

  if (!currentUserHasLoaded) {
    return <Loading />;
  }

  const LoggedInHomeComponent = shouldShowNewParentDashboard
    ? ParentDashboardV2
    : LoggedInHome;
  const path = shouldShowNewParentDashboard
    ? (DASHBOARD_LINKS.map(link => link.to) as string[])
    : "/";

  return (
    <>
      <div data-test-id="logged_in_home" />
      <Switch>
        <Route
          exact
          path={path}
          component={isLoggedIn ? LoggedInHomeComponent : LoggedOutUserHome}
        />
        {/* Non-existing routes will be caught here */}
        <Route component={NotFoundPage} />
      </Switch>
    </>
  );
}
